"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.merchantProductImport = merchantProductImport;
exports.merchantProductListApi = merchantProductListApi;
exports.merchantProductPriceUpdateApi = merchantProductPriceUpdateApi;
exports.offShellApi = offShellApi;
exports.productHeadersApi = productHeadersApi;
exports.productImportShellApi = productImportShellApi;
exports.productStatisticsHeadersApi = productStatisticsHeadersApi;
exports.removeShellApi = removeShellApi;
exports.upShellApi = upShellApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

function merchantProductPriceUpdateApi(data) {
  return (0, _request.default)({
    url: '/admin/retailer/product/customer/update',
    method: 'post',
    data: data
  });
}
function offShellApi(data) {
  return (0, _request.default)({
    url: "/admin/retailer/product/force/down",
    method: 'post',
    data: data
  });
}
function productImportShellApi(data) {
  return (0, _request.default)({
    url: "/admin/retailer/product/import/select",
    method: 'post',
    data: data
  });
}
function upShellApi(data) {
  return (0, _request.default)({
    url: "/admin/retailer/product/force/up",
    method: 'post',
    data: data
  });
}
function removeShellApi(data) {
  return (0, _request.default)({
    url: "/admin/retailer/product/force/remove",
    method: 'post',
    data: data
  });
}

/**
 * 商户 商品 配置 列表
 */
function merchantProductListApi(params) {
  return (0, _request.default)({
    url: '/admin/retailer/product/list',
    method: 'get',
    params: params
  });
}
function merchantProductImport(id) {
  return (0, _request.default)({
    url: "/admin/retailer/product/import",
    method: 'get'
  });
}
function productHeadersApi() {
  return (0, _request.default)({
    url: "/admin/retailer/product/tabs/headers",
    method: 'get'
  });
}
function productStatisticsHeadersApi() {
  return (0, _request.default)({
    url: "/admin/retailer/product/statistics/headers",
    method: 'get'
  });
}